export default {
	system: {
		title: '智慧路灯云平台系统',
		gas_data: [
			"北风",
			"东北风",
			"东风",
			"东南风",
			"南风",
			"西南风",
			"西风",
			"西北风"
		],
		no_data: '暂无数据！',
		login_out_tip: '您确定注销退出系统吗？',
		exit: '退出',
		more: '更多',
		username: '登录用户名',
		password: '登录密码',
		login: '立即登录',
		password_tip1: '密码长度8-20个字(大写字母、小写字母、数字、特殊字符至少两项！)',
		password_tip2: '密码长度必须6-20个字！',
		password_tip3: '请输入密码',
		password_tip4: '密码不能与用户名或用户名的倒序相同',
		please_username: '请输入用户名',
		username_tip: '用户名长度在 4 到 12 个字符',
		login_tip: '免密登录需要user参数！',
		error: '错误',
	},
	control: {
		lamp_control: '路灯控制',
		camera:'摄像头',
		number: '编号',
		name: '名称',
		model: '型号',
		address: '地址',
		frequency:'次数',
		ip: 'IP',
		strategy: '策略',
		add: '添加',
		edit: '编辑',
		delete: '删除',
		remove: '移除',
		set: '设置',
		reset: '重置',
		all: '全部',
		open: '打开',
		open_kq: '开启',
		close: '关闭',
		play: '播放',
		order: '排序',
		desc: '备注',
		submit: '提交',
		all_open: '全开',
		all_close: '全关',
		all_auto: '全自动',
		all_manual: '全手动',
		import: '导入',
		batch_import: '批量导入',
		down_temp: '下载模板文件',
		online: '在线',
		offline: '离线',
		date: '日期',
		start_date: '开始日期',
		over_date: '结束日期',
		time: '时间',
		start_time: '开始时间',
		over_time: '结束时间',
		any_date: '任意时间点',
		select_date: '选择日期',
		select_time: '选择时间',
		start_end_time: '起始时间',
		month: '月份',
		start_month: '开始月份',
		over_month: '结束月份',
		now_month: '本月',
		year_now: '今年至今',
		near_month6: '最近六个月',
		search: '搜索',
		add_success: '添加成功！',
		mod_success: '修改成功！',
		del_success: '删除成功！',
		operation_success: '操作成功！',
		import_success: '导入成功！',
		upload_success: '上传成功！',
		command_success: '下发成功!',
		refresh_success: '刷新成功!',
		error: '错误，',
		import_limitation:'导入文件只能是xlsx格式文件！',
		cancel_del: '已取消删除',
		confirm: '确定',
		cancel: '取消',
		tip: '提示',
		got_it: '知道了',
		tip_del_device_title: '本操作将永久删除该设备，是否继续？',
		tip_del_data_title: '本操作将永久删除该条信息，是否继续？',
		select_file: '选择文件',
		file_upload: '文件上传',
		to: '至',
		operate: '操作',
		longitude: '经度',
		latitude: '纬度',
		lng_lat: '经纬度',
		year: '年',
		month: '月',
		day: '日',
		hour: '小时',
		minute: '分钟',
		second: '秒',
		select_month: '选择月份',
		set_success: '设置成功',
		select_device: '请选择设备',
		yes: '是',
		no: '否',
	},
	home: {
		box1:{
			title: '灯杆概览',
			text1: '灯杆总数',
			text2: '使用能耗',
			text3: '节约能耗',
			text4: '智慧云盒',
			text5: '广播',
			text6: '监控摄像',
			text7: '气象站',
			text8: '5G基站',
			text9: '一键报警',
			text10: '充电桩',
			text11: '在线数',
			text12: '离线数',
			text13: '亮灯数',
		},
		box2:{
			title: '网络广播',
			text1: '全部',
			text2: '在线设备',
			text3: '离线设备',
			unit: '台'
		},
		box3:{
			title: '设备统计',
			deviceArr: ['广播', '监控', '一键报警', '环境监测']
		},
		box4:{
			title: '环境检测',
			text1: '温度',
			text2: '湿度',
			text3: '光照度',
			text4: '风速',
			text5: '风向',
			text6: '噪声',
			text7: '大气压'
		},
		box5:{
			title: '广告显示',
			text1: '屏幕总数',
			text2: '节目单总数',
			text3: '暂无投屏'
		},
		box6:{
			title: '告警记录',
			text1: '设备识别号',
			text2: '报警时间',
			text3: '报警内容',
			text4: '暂无报警信息',
			text5: '设备',
			text6: '在',
		},
		box7:{
			title: '智能监控'
		}
	},
	gis:{
		please_name: '请输入设备名称',
		view_camera: '查看设备监控',
		location_failed: '获取定位失败，请移动地图定位位置',
		please_search_address: '请输入检索地址',
		nationwide: '全国',
		not_support: '根据地址查询位置失败，所选地点不支持！',
		please_hand: '根据地址查询位置失败，请手动拖动地图标记！',
	},
	device: {
		lamp: '灯',
		lamp1: '灯1',
		lamp2: '灯2',
		number: '设备编号',
		freq_level_arr: ['离线', '极弱', '弱', '中', '强', '极强', '未知'],
		id:'设备ID',
		please_id:'请输入设备ID',
		please_name: '请输入名称',
		please_device_name: '请输入设备别名',
		please_device_number: '请输入设备编号',
		device_number: '设备编号',
		device_name: '设备名称',
		device_model: '设备型号',
		company: '所属公司',
		project: '所属项目',
		group: '所属分组',
		state: '状态',
		strategy: '所属策略',
		belong_lamp: '所属路灯',
		time_frame: '时间范围',
		select_company: '请选择所属公司',
		select_project: '请选择所属项目',
		select_group: '请选择所属分组',
		select_state: '选择状态',
		select_strategy: '请选择所属策略',
		batch_set_mode: '批量设置路灯模式',
		single: '单灯',
		double: '双灯',
		single_Double: '单/双灯',
		select_single_Double: '请选择单/双灯',
		device_version: '设备版本',
		versionArr:['旧版','新版'],
		switch_state: '开关状态',
		light: '亮度',
		light_control: '亮度/控制',
		current_strategy: '当前策略',
		online_status: '在线状态',
		current: '电流(A)',
		voltage: '电压(V)',
		power: '功率(W)',
		show_data: '显示数据',
		select_protocol: '路灯协议',
		gateway_number: '网关编号',
		is_home: '是否首页显示',
		is_sensor: '是否安装环境传感器',
		light_control: '亮度控制',
		detail:	'详情信息',
		lampTypeList: ['', '普通路灯', '市电路灯', '太阳能', 'PLC路灯'],
		doubleType: ["单灯", "双灯"],
		steList: ["离线", "在线"],
		lightStatus: ["关灯中", "亮灯中"],
		msList: ["(自动)", "(手动)"],
		refresh: '刷新',
		attribute: '属性',
		detail_text1: '灯头号',
		detail_text2: '温度',
		detail_text3: '太阳板电压',
		detail_text4: '蓄电池电压',
		detail_text5: '充电电流',
		detail_text6: '放电电压',
		detail_text7: '放电电流',
		detail_text8: '总充电安时数',
		detail_text9: '总放电安时数',
		detail_text10: '电压',
		detail_text11: '电流',
		detail_text12: '电量',
		detail_text13: '总电量',
		detail_text14: '漏电压',
		detail_text15: '漏电流',
		detail_text16: '功率',
		detail_text17: '功率因数',
		detail_text18: '工作时长',
		edit_trategy: '修改策略',
		please_select: '请选择',
		control_mode: '控制模式',
		msArr: ["自动", "手动"],
		lamp_light: '灯亮度',
		lamp1_light: '灯1亮度',
		lamp2_light: '灯2亮度',
		please_strategy: '请选择策略',
		please_set_light: '请设置灯亮度',
	},
	lampGroup: {
		group_name: '路灯编组名称',
		group_type: '单/双灯类型',
		manage: '管理路灯',
		desc: '路灯编组说明',
		control: "灯组控制",
		open: '开灯',
		close: '关灯',
		set_light_text: '设置分组下所有路灯的亮度',
		doubleType: ["单灯组", "双灯组"],
		form_group_name: '请输入编组名称',
		add_new: '新增关联路灯',
		bind: '绑定',
		bind_tip: '绑定成功',
		unbind: '解绑',
		unbind_tip: '解绑成功',
		association: '关联路灯',
		select_lamp: '选择路灯(可搜索)',
	},
	lampStrategy: {
		time_strategy: '定时策略',
		area_strategy: '区域策略',
		mode: '单/双灯模式',
		select_mode: '请选择单/双灯模式',
		strategy_name: '策略名称',
		input_strategy_name: '请输入策略名称',
		strategy_type: '策略类型',
		strategy_content: '策略内容',
		select_strategy_type: '选择策略类型',
		system_strategy: '系统策略',
		offline_strategy: '系统策略',
		modelType: ['未知', '系统策略', '脱机策略'],
		time_strategy_tip: '根据您设置的时间策略，绑定到路灯上，路灯定时开关灯和调光',
		area_strategy_tip: '设置了区域策略后，绑定的路灯会根据经纬度算出该地日出日落的时间，根据太阳光线强弱，路灯自动调光和开关',
		time_table: '时间表',
		set_lamp2: '一键设置灯',
		number: 'NO',
		number1: 'NO.1',
		number2: 'NO.2',
		input_lamp_name: '请输入路灯别名或序列号',
		lamp_can: '该策略可选路灯',
		lamp_have: '该策略已选路灯',
		offline_must6: '脱机策略中策略时间最多6条！',
		offline_must2: '脱机策略中策略时间最少2条！',
		time_table_must1: '策略时间表至少存在一条！',
		delect_time_table: '确定要删除这个时间段？',
		no1_tip: '第1条为每天开灯时间，请设置亮度！',
		no1_tip2: '第2条为每天关灯时间，请把亮度设置为0！',
		time_table_must1: '策略时间表至少存在一条！',
		please_set_lamp1: '请先设置完灯1',
		delete_strategy_tip: '本操作将永久删除该条策略，是否继续？',
		sunset_time: '日落时间',
		sunrise_time: '日出时间',
		advance: '提前',
		set_advance: '设置提前',
		delay: '延迟',
		set_delay: '设置延迟',
		no_set: '未设置',    
		open_time: '开灯时间',
		close_time: '关灯时间',
		add_area_strategy: '新增日出日落策略',
		edit_area_strategy: '编辑日出日落策略',
		enter_lng_lat: '请输入经纬度',
		enter_lng: '请输入经度',
		enter_lat: '请输入纬度',
		to_be_open_time: '预计开灯时间',
		enter_open_time: '请输入开灯时间',
		to_be_close_time: '预计关灯时间' ,
		enter_close_time: '请输入关灯时间',
		lamp_light_set: '路灯亮度调节',
		area_strategy_must1: '区域策略只能存在一条！',
		area_from_tip1: '请输入策略名称！',
		area_from_tip2: '请输入策略类型！',
		area_from_tip3: '请输入经纬度！',
		area_from_tip4: '开灯时间不能为空！',
		area_from_tip5: '关灯时间不能为空！',
		area_from_tip6: '日落开灯亮度应大于0！',
		is_advance: '是否提前',
		operation_type: '操作类型',
		advance_time: '提前时间（分钟）',
		is_delay: '是否延迟',
		delay_time: '延迟时间（分钟）',
		time_slot: '时间段',
		add_time_slot: '新建时间段',
		please_add_time_slot: '请新建时间段',
		do_not_repeat: '请不要选择重复时间段',
	},
	sunStrategy: {
		plan_name: '计划名称',
		input_plan_name: '请输入策计划名称',
		device_model: '设备型号',
		device_model_id: '设备型号',
		switch_mode: '运行模式',
		switch_mode_arr: ['未知', '普通', '节能'],
		run_mode: '开关灯模式',
		run_mode_arr: ['未知', '光控开灯-光控关灯', '市电开-市电关', '光控开灯-时控关灯', '时控开灯-时控关灯'],
		start_time: '开始时间',
		create_by: '创建时间',
		strategy_content: '策略内容',
		select_strategy_type: '选择策略类型',
		system_strategy: '系统策略',
		offline_strategy: '系统策略',
		modelType: ['未知', '系统策略', '脱机策略'],
		time_strategy_tip: '根据您设置的时间策略，绑定到路灯上，路灯定时开关灯和调光',
		area_strategy_tip: '设置了区域策略后，绑定的路灯会根据经纬度算出该地日出日落的时间，根据太阳光线强弱，路灯自动调光和开关',
		time_table: '时间表',
		set_lamp2: '一键设置灯',
		number: 'NO',
		number1: 'NO.1',
		number2: 'NO.2',
		input_lamp_name: '请输入路灯别名或序列号',
		lamp_can: '该策略可选路灯',
		lamp_have: '该策略已选路灯',
		offline_must6: '脱机策略中策略时间最多6条！',
		offline_must2: '脱机策略中策略时间最少2条！',
		time_table_must1: '策略时间表至少存在一条！',
		delect_time_table: '确定要删除这个时间段？',
		no1_tip: '第1条为每天开灯时间，请设置亮度！',
		no1_tip2: '第2条为每天关灯时间，请把亮度设置为0！',
		time_table_must1: '策略时间表至少存在一条！',
		please_set_lamp1: '请先设置完灯1',
		delete_strategy_tip: '本操作将永久删除该条策略，是否继续？',
		sunset_time: '日落时间',
		sunrise_time: '日出时间',
		advance: '提前',
		set_advance: '设置提前',
		delay: '延迟',
		set_delay: '设置延迟',
		no_set: '未设置',    
		open_time: '开灯时间',
		close_time: '关灯时间',
		add_area_strategy: '新增日出日落策略',
		edit_area_strategy: '编辑日出日落策略',
		enter_lng_lat: '请输入经纬度',
		enter_lng: '请输入经度',
		enter_lat: '请输入纬度',
		to_be_open_time: '预计开灯时间',
		enter_open_time: '请输入开灯时间',
		to_be_close_time: '预计关灯时间' ,
		enter_close_time: '请输入关灯时间',
		lamp_light_set: '路灯亮度调节',
		area_strategy_must1: '区域策略只能存在一条！',
		area_from_tip1: '请输入策略名称！',
		area_from_tip2: '请输入策略类型！',
		area_from_tip3: '请输入经纬度！',
		area_from_tip4: '开灯时间不能为空！',
		area_from_tip5: '关灯时间不能为空！',
		area_from_tip6: '日落开灯亮度应大于0！',
		is_advance: '是否提前',
		operation_type: '操作类型',
		advance_time: '提前时间（分钟）',
		is_delay: '是否延迟',
		delay_time: '延迟时间（分钟）',
		time_slot: '时间段',
		add_time_slot: '新建时间段',
		please_add_time_slot: '请新建时间段',
		do_not_repeat: '请不要选择重复时间段',
	},
	gateway:{
		name: '网关名称',
		number: '网关编号',
		type: '网关类型',
		state: '状态',
		env_sensor: '环境传感器',
		env_sensor_install: '是否安装环境传感器',
		tilt_sensor: '倾斜传感器',
		tilt_sensor_install: '是否安装倾斜传感器',
		is_home: '是否首页显示',
		typeArr: ['','4G网关','LoRa网关'],
		envArr: ["未安装", "已安装"],
		refresh_3: '刷新三相电',
	},
	log: {
		behavior_type: '所属行为类型',
		select_behavior_type:'请选择行为类型',
		number: '设备号',
		name: '行为名称',
		content: '行为内容',
		logTypeArr: ['', '数据上报', '控制下发', '控制回复', '心跳回复', '报警数据', '策略下发'],
	},
	alarm: {
		warn:'报警',
		warn_type:'报警类型',
		select_warn_type:'请选择报警类型',
		warn_content:'报警内容',
		processing_status:'处理状态',
		processed:'已处理',
		success: '处理成功',
		arrSte: ["未处理", "已处理"],
		arrType: ["", "电压", "电流", "路灯故障", "离线"],
	},
	concentrator: {
		loop: '回路',
		select_loop: '请选择回路',
		loop_control: '回路控制',
		current_ratio: '电流变速比',
		mail_address: '通讯地址',
		open_connect: '开-连通',
		close_break: '关-断开',
		expect: '预计',
		input_device_name: '请输入集中器名称',
		device_can: '可选集中器',
		device_have: '已选集中器',
		energize_time: '选择通电时间',
		outage_time: '选择通电时间',
		loop_strategy_max6: '回路策略最多六条！',
		loop_strategy_min1: '回路策略至少存在一条！',
		loop_only1_strategy: '每个回路只能有一条策略！',
		loop_number: '集中器编号',
		enter_loop_number: '请输入集中器编号',
		input_number: '请先输入编号，检索出集中器！',
		strategy: '集控策略',
		loop_strategy: '回路策略',
		plan: '计划',
		delete_paln_tip: '确定要删除这个计划？',
		please_strategy_name: '策略名称不能为空',
		please_plan: '请填写计划！',
		please_name: '请输入策略名',
		fen_arr: ['未分配的设备', '已分配的设备'],
		list_arr: ['从列表删除', '添加到列表'],
		back: '返回',
		allocation_succ: '分配成功',
		unassigned_succ: '取消分配成功',
		steType: ["关", "开"],
	},
	camera: {
		camera_list: '摄像头列表',
		config_edit: '配置修改',
		delete_camera: '删除摄像头',
		add_camera: '摄像头添加',
		edit_camera: '摄像头配置修改',
		name: '摄像头名称',
		enter_name: '请输入摄像头名称',
		number: '摄像头编号',
		enter_number: '请输入摄像头编号',
		type: '摄像头协议',
		select_type: '请选择摄像头协议',
		haikang: '海康萤石云',
		dahua: '大华乐橙云',
		qiniuyun: '七牛云',
		qiniuyun_key: '七牛云KEY',
		enter_qiniuyun_key: '请输入七牛云KEY',
		qiniuyun_secret: '七牛云SECRET',
		enter_qiniuyun_secret: '请输入七牛云SECRET',
		select_lamp: '选择路灯',
		enter_select_lamp: '请选择所属路灯',
		is_home: '首页显示',
		delete_camera_tip: '本操作将永久删除该摄像头，是否继续？',
		slow: '慢',
		fast: '快',
		no_camera: '暂无监控',
		please_select_camera: '请先选择摄像头， 然后进行云台控制!'
	},
	broadcast: {
		volume: '音量',
		set_volume: '设置音量',
		enter_volume: '请输入声音',
		volume_start: '初始音量',
		task_name: '任务名',
		enter_task_name: '请输入任务名',
		device_id: '设备ID',
		cycles_number: '循环次数',
		enter_cycles_number: '请输入循环次数',
		media_list: '播放媒体列表',
		play_music: '音乐播放',
		add_task: '添加广播任务',
		edit_task: '修改广播任务',
		select_device: '选择广播设备',
		set_cycles: '设置循环次数',
		music_list: '实时广播音乐列表',
		plan_name: '计划名',
		enter_plan_name: '请输入计划名',
		start_plan_time: '开始执行时间',
		plan_task: '执行的任务',
		select_plan_task: '请选择执行的任务',
		select_task_name: '执行的任务名/任务ID',
		is_enable: '是否启用计划',
		add_plan: '添加广播计划',
		edit_plan: '修改广播计划',
		system_file_name: '文件系统的别名',
		select_media: '选择媒体文件',
		add_media: '添加媒体文件',
		edit_media: '修改媒体文件',
		file_name: '文件名',
		enter_file_name: '请输入文件名',
		mp3_file: 'mp3文件',
		mp3_file_upload: '点击MP3上传',
		just_mp3: '上传文件只能是mp3格式！',
		mic_id: '话筒设备ID',
		mic_ip: '话筒设备ip',
		terminal_id: '设备终端ID',
		mic_state: '话筒状态',
		link_status: '链接状态',
		open_mic: '开启网络话筒',
		select_broadcast: '设备终端编号',
		open_mic_successs: '网络话筒打开成功',
		close_mic_successs: '网络话筒打开成功',
		file_id: '文件ID',
		file_name: '文件名',
		add_music: '添加音乐',
		edit_music: '修改音乐',
		select_music: '选择音乐（可搜索）',
	},
	screen: {
		click_open: '一键开屏',
		click_close: '一键关屏',
		refresh_list: '刷新列表数据',
		name: '屏幕名称',
		number: '屏幕编号',
		area_code: '区号',
		lamp_name: '所属路灯',
		select_lamp_name: '请选择所属路灯',
		brand: '厂家',
		select_brand: '请选择屏幕厂家',
		state: '屏幕状态',
		device_mode: '设备模式',
		select_device_mode: '请选择设备模式',
		add_time: '添加时间',
		update_time: '更新时间',
		brand1: '仰邦',
		brand2: '熙讯',
		brand3: '卡莱特',
		brand4: '诺瓦',
		screenType: ['仰邦','熙讯','','卡莱特','诺瓦'],
		public_network: '公网',
		intranet: '内网',
		patternType: ["公网", "内网"],
		select_screen: '请选择选择屏幕',
		add_program:'新建节目单',
		edit_program:'修改节目单',
		screen_allocation: '屏幕分配',
		put_in: '即时投放',
		program_allocation: '节目单分配',
		task_name: '任务名称',
		implement_programs: '执行的节目单',
		select_implement_programs: '请选择执行的节目单',
		task_addition_time: '任务添加时间',
		task_state: '任务状态(未启用/已启用)',
		start_and_end_date: '任务起始日期',
		meidia_name: '素材名称',
		meidia_name_tip: '请输入素材名称',
		meidia_type: '素材类型',
		meidia_url: '素材路径',
		click_upload: '点击上传素材',
		video_upload: '视频上传',
		pic_upload: '图片上传',
		edit_text: '文字编辑',
		edit_text_tip: '请输入内容,Enter可换行',
		typeArr: ['Text','Picture','Video'],
		just_pic: '上传图片只能是jpg、png格式！',
		just_mp4: '上传视频只能mp4格式！',
		program_name: '节目单名称',
		please_program_name: '请输入节目单名称',
		screen_fen: ['未分配的屏幕', '已分配的屏幕'],
		versionType: ['开发版', '嵌入版'],
		screen_token: '嵌入版Token(卡莱特)',
		information_account: '仰邦屏账号',
		information_password: '仰邦屏密码',
		app_key: '萤石云key',
		app_secret: '萤石云secret',
		imou_key: '乐橙云key',
		imou_secret: '乐橙云secret',
		qiniu_key: '七牛云key',
		qiniu_secret: '七牛云secret',
		charging_type: '充电桩版本',
		charging_account: '充电桩账号',
		charging_password: '充电桩密码',
		api_key: 'oneNet平台key',
		broadcast: '一键报警服务器IP'
	},
	ai:{
		warn_time: '报警时间',
		warn_camera: '报警摄像头',
		camera_number: '摄像头Number',
		camera_remark: '摄像头摘要',
		warn_log: '全部日志',
		warn_view: '报警预览',
		warn_info: '报警信息',
		warn_photo: '报警快照',
		warn_video: '实时视频',
		warn_desc: '报警摘要',
		go: '进入',
		reception: '报警接收',
		arrSte: ["未处理", "已处理", "误报"],
		typeArr: ["进入", "离开", "停车"],
		records: '处理记录',
	},
	car: {
		identify_time: '识别时间',
		original: '原图',
		view: '点击查看',
		license_plate: '识别车牌',
		car_type: '车牌类型',
		run_direction: '车辆行驶方向',
		use_time: '识别用时（s）',
		less0: '少于0秒',
		device_number: '设备识别号',
		device_ip: '设备IP',
		mark: '标记',
		normal: '正常',
		unmark: '取消标记',
		mark_data: '标记数据',
		identify_pic: '识别图',
		viewed: '已查看记录',
		mark_as_viewed: '标记该记录',
		car_pass: '车辆通过'
	},
	manhole: {
		warn_log: '报警日志',
		communicatio_id: '通讯ID',
		describe: '描述',
		steArr: ["正常", "打开", "松动", "正常"],
		waterArr: ["正常", "水满", "中水位", "低水位"],
		overflow:'溢出',
		sheArr: ["未设防", "已设防"],
		undefended: '未设防',
		defensed: '已设防',
		temp: '温度',
		battery: '剩余电量',
		water_level: '水位',
		presence: '在线状态',
		defense_status: '设防状态',
		device_status: '设备实际状态',
		oblique_state: '倾斜状态',
		command_down: '命令已下发至缓存中，等待下次设备唤醒时运行！',
		logType: ["正常", "打开", "松动", "复位", "水溢出", "设备移开", "温度传感器异常", "角度传感器异常"],
	},
	manage: {
		company: '公司名称',
		please_company: '请输入公司名称',
		company_logo: '公司logo',
		system_logo: '系统logo',
		keywords: '请输入关键字',
		title: '系统标题',
		province: '省份',
		city: '城市',
		area: '区县',
		upload: '点击上传',
		del_tip: '本操作将永久删除该公司，是否继续？',
		png_tip: '公司LOGO只能是png格式的透明图片！',
		pic_tip: '只能上传png文件，且不超过500kb',
		user_account: '用户账号',
		password: '账户密码',
		phone: '联系电话',
		contact: '联系人',
		add_user: '新建用户',
		user_id: '用户ID',
		basic_config: '基础配置',
		column_config: '栏目配置',
		is_enabled: '是否启用',
		enabled: '启用',
		disable: '禁用',
		arrState: ['禁用','启用'],
		auth: '权限管理',
		column: '栏目',
		set_password: '请设置密码！',
		project_name: '项目名称',
		project_id: '项目ID',
		project_manager: '项目管理员',
		project_address: '项目所在地',
		none: '暂无',
		max_access: '最大接入数量',
		access_status: '接入状态',
		due_Date: '到期日期',
		access_level: '接入状态等级',
		address: '详细地址',
		access_status_arr: ['试用接入', '申请接入', '正常接入'],
		tiday: '今天',
		after_month1: '1个月后',
		after_month3: '3个月后',
		after_month6: '6个月后',
		after_year1: '1年后',
		after_year2: '2年后',
		forever: '永久',
		lnglat_none: '该设备经纬度未标记！',
		operation_date: '操作日期',
		login_ip: '登录的IP地址',
		operation_content: '操作内容',
		login_date: '登录日期',
	},
	other: {
		goSystem: '进入系统'
	}
}
